import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { emissionChildrenRoutes } from './emissionChildrenRoutes';

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));

interface RouteItem {
  path: string;
  element: JSX.Element;
}

const emissionRoutes = {
    path: '/emision',
    element: <Outlet />,
    errorElement: <NotFoundPage />,
    children: [
      ...emissionChildrenRoutes.map(({ path, element }: RouteItem) => ({
        path,
        element,
      })),
    ],
  }
;

export default emissionRoutes;
